module.exports = "<app-loading></app-loading>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/auto-login/auto-login.component.html
// module id = ../../../../../src/app/component/auto-login/auto-login.component.html
// module chunks = main